<script></script>

<template>
  <bv-view />
</template>
